"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const R = __importStar(require("ramda"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_apollo_1 = require("react-apollo");
const TableSchemaContext_1 = require("./TableSchemaContext");
exports.TABLE_FIELD_FRAGMENT = graphql_tag_1.default `
  fragment TableFieldFragment on TableField {
    ...CommonTableFieldFragment
    fieldTypeAttributes {
      ...TextFieldTypeAttributes
      ...NumberFieldTypeAttributes
      ...FileFieldTypeAttributes
      ...DateFieldTypeAttributes
      ...SwitchFieldTypeAttributes
      ...SmartFieldTypesAttributes
      ...MissingRelationFieldTypeAttributes
      ...GeoFieldTypeAttributes
    }
  }

  fragment CommonTableFieldFragment on TableField {
    id
    name
    displayName
    table {
      id
      name
      displayName
    }
    description
    fieldType
    fieldTypeAttributes {
      ...TextFieldTypeAttributes
      ...NumberFieldTypeAttributes
      ...FileFieldTypeAttributes
      ...DateFieldTypeAttributes
      ...SwitchFieldTypeAttributes
      ...MissingRelationFieldTypeAttributes
      ...GeoFieldTypeAttributes
    }
    isList
    isRequired
    isUnique
    defaultValue
    isSystem
    isMeta
    relation {
      refFieldName
      refFieldDisplayName
      relationTableName
      relationFieldName
      refTable {
        id
        name
        displayName
      }
      refField {
        id
        name
        displayName
      }
      refFieldIsList
      refFieldIsRequired
    }
    schemaFeatures {
      update
      delete
    }
    dataFeatures {
      create
      update
    }
    computedMode
    expression
  }

  fragment DateFieldTypeAttributes on DateFieldTypeAttributes {
    format
  }

  fragment TextFieldTypeAttributes on TextFieldTypeAttributes {
    format
    fieldSize
  }

  fragment NumberFieldTypeAttributes on NumberFieldTypeAttributes {
    format
    precision
    currency
    minValue
    maxValue
    isBigInt
    autoIncrement
  }

  fragment FileFieldTypeAttributes on FileFieldTypeAttributes {
    format
    maxSize
    typeRestrictions
  }

  fragment GeoFieldTypeAttributes on GeoFieldTypeAttributes {
    format
  }

  fragment SmartFieldTypesAttributes on SmartFieldTypeAttributes {
    format
    innerFields {
      name
      displayName
      description
      fieldType
      isList
      isRequired
      isUnique
      fieldTypeAttributes {
        ...TextFieldTypeAttributes
        ...NumberFieldTypeAttributes
        ...FileFieldTypeAttributes
        ...DateFieldTypeAttributes
        ...SwitchFieldTypeAttributes
        ...MissingRelationFieldTypeAttributes
        ...GeoFieldTypeAttributes
      }
    }
  }

  fragment SwitchFieldTypeAttributes on SwitchFieldTypeAttributes {
    format
    listOptions
  }

  fragment MissingRelationFieldTypeAttributes on MissingRelationFieldTypeAttributes {
    missingTable
  }
`;
exports.TABLE_FRAGMENT = graphql_tag_1.default `
  fragment TableFragment on Table {
    id
    name
    displayName
    description
    application {
      id
      name
      displayName
      description
      status
      appType
    }
    indexes {
      id
      type
      columns {
        name
      }
      name
      isSystem
    }
    origin {
      type
      provider
    }
    isSystem
    fields {
      ...TableFieldFragment
    }
    attributes {
      ...TableAttributesFragment
    }
    schemaFeatures {
      create {
        DATE
        FILE
        JSON
        NUMBER
        RELATION
        SMART
        SWITCH
        TEXT
        UUID
        GEO
      }
      update {
        displayName
        name
      }
    }
    dataFeatures {
      create
      update
      delete
    }
  }

  fragment TableAttributesFragment on TableAttributes {
    ...TableViewAttributesFragment
  }

  fragment TableViewAttributesFragment on ViewAttributes {
    query
  }

  ${exports.TABLE_FIELD_FRAGMENT}
`;
exports.APPLICATIONS_FRAGMENT = graphql_tag_1.default `
  fragment ApplicationFragment on Application {
    id
    name
    displayName
    description
    createdAt
    appType
    status
  }
`;
exports.TABLES_SCHEMA_QUERY = graphql_tag_1.default `
  query TablesSchema {
    tablesList {
      items {
        ...TableFragment
      }
      count
    }

    applicationsList {
      items {
        ...ApplicationFragment
      }
      count
    }
  }

  ${exports.TABLE_FRAGMENT}
  ${exports.APPLICATIONS_FRAGMENT}
`;
/**
 * Provider for 8base table schemas
 * @property {Function} children Children of the provider. Could be either react node or function with loading state.
 */
class TableSchemaProvider extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.renderChildren = (args) => {
            const { children } = this.props;
            if (typeof children === 'function') {
                return children(args);
            }
            return children;
        };
        this.renderContent = ({ data, loading, error } = { loading: false }) => {
            return (react_1.default.createElement(TableSchemaContext_1.TableSchemaContext.Provider, { value: {
                    tablesList: R.pathOr([], ['tablesList', 'items'], data),
                    applicationsList: R.pathOr([], ['applicationsList', 'items'], data),
                    loading,
                    error,
                } }, this.renderChildren({ loading, error })));
        };
    }
    render() {
        const _a = this.props, { children, tablesList, applicationsList } = _a, rest = __rest(_a, ["children", "tablesList", "applicationsList"]);
        if (tablesList) {
            return (react_1.default.createElement(TableSchemaContext_1.TableSchemaContext.Provider, { value: {
                    tablesList,
                    applicationsList: applicationsList || [],
                    loading: false,
                } }, this.renderChildren({ loading: false })));
        }
        return (react_1.default.createElement(react_apollo_1.Query, Object.assign({ query: exports.TABLES_SCHEMA_QUERY }, rest), this.renderContent));
    }
}
exports.TableSchemaProvider = TableSchemaProvider;
//# sourceMappingURL=TableSchemaProvider.js.map